module.exports = __webpack_public_path__ + "img/cancel-face.8ac90280.svg";